import { Timeline } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { ITimeLineHistoricoDespesaDTO } from '../../../../models/happy-code-api.model';
import Styles from '../despesa.module.scss';
import { formattedDate } from '../../../../util/format';

dayjs.locale('pt-br');

interface Props {
	despesaHistory: ITimeLineHistoricoDespesaDTO[];
  dataCriacao: Date;
}

export const TimelineHistorico = ({ despesaHistory, dataCriacao }: Props) => {
	const formatValor = (campo: string, valor: string) => {
		if (!valor) return 'vazio';
		if (!campo) return 'vazio';

		const camposDeData = ['Competência', 'Vencimento', 'Data de Pagamento'];

		if (camposDeData.includes(campo)) {
			return formattedDate(valor);
		}

		return valor;
	};

	const wasDeleted = (campo: string) => {
		if (campo.toLowerCase().includes('excluído')) return true;
	};
	return (
		<div className={Styles.observacoesContent}>
			<Timeline mode="left">
				<Timeline.Item className={Styles.firstItem}>
					<div className={Styles.timelineFirst}>Primeira vez cadastrada em <br></br>{formattedDate(dataCriacao)}</div>
				</Timeline.Item>
				{despesaHistory.map((item, idx) => {
					const when = dayjs(item.dataAlteracao).format('DD/MM/YYYY HH:mm');
					return (
						<Timeline.Item key={idx} color={wasDeleted(item.campo) ? 'red' : 'blue'}>
							<div className={Styles.timelineItemContent}>
								<div className={Styles.timelineHeader}>
									<span className={Styles.timelineCampo}>Alteração: {item.campo}</span>
									<span className={Styles.timelineDate}>{when}</span>
								</div>
								<div className={Styles.timelineBody}>
									<div className={Styles.timelineValor}>
										<span style={{ fontWeight: '600' }} className={Styles.timelineCampo}>Novo valor: </span>
									<span style={wasDeleted(item.campo) && { textDecoration: 'line-through' }}>	{formatValor(item.campo, item.valorAntigo)}</span>
									</div>
									<span className={Styles.timelineMeta}>
										por <strong>{item.usuario}</strong>
									</span>
								</div>
							</div>
						</Timeline.Item>
					);
				})}
			</Timeline>
		</div>
	);
};
